// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/chat_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_chat_chat } from "../model/chat/chat_pb";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_core_paging } from "../model/core/paging_pb";

/**
 * Describes the file proto/service/chat_service.proto.
 */
export const file_proto_service_chat_service = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_proto_model_chat_chat, file_proto_model_core_model_path, file_proto_model_core_paging]);

/**
 * Describes the message carmen.CreateThreadRequest.
 * Use `create(CreateThreadRequestSchema)` to create a new message.
 */
export const CreateThreadRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 0);

/**
 * Describes the message carmen.CreateThreadResponse.
 * Use `create(CreateThreadResponseSchema)` to create a new message.
 */
export const CreateThreadResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 1);

/**
 * Describes the message carmen.GetThreadRequest.
 * Use `create(GetThreadRequestSchema)` to create a new message.
 */
export const GetThreadRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 2);

/**
 * Describes the message carmen.GetThreadResponse.
 * Use `create(GetThreadResponseSchema)` to create a new message.
 */
export const GetThreadResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 3);

/**
 * Describes the message carmen.ListThreadsRequest.
 * Use `create(ListThreadsRequestSchema)` to create a new message.
 */
export const ListThreadsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 4);

/**
 * Describes the message carmen.ListThreadsResponse.
 * Use `create(ListThreadsResponseSchema)` to create a new message.
 */
export const ListThreadsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 5);

/**
 * Describes the message carmen.UpdateThreadRequest.
 * Use `create(UpdateThreadRequestSchema)` to create a new message.
 */
export const UpdateThreadRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 6);

/**
 * Describes the message carmen.UpdateThreadResponse.
 * Use `create(UpdateThreadResponseSchema)` to create a new message.
 */
export const UpdateThreadResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 7);

/**
 * Describes the message carmen.DeleteThreadRequest.
 * Use `create(DeleteThreadRequestSchema)` to create a new message.
 */
export const DeleteThreadRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 8);

/**
 * Describes the message carmen.DeleteThreadResponse.
 * Use `create(DeleteThreadResponseSchema)` to create a new message.
 */
export const DeleteThreadResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 9);

/**
 * Describes the message carmen.CreateMessageRequest.
 * Use `create(CreateMessageRequestSchema)` to create a new message.
 */
export const CreateMessageRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 10);

/**
 * Describes the message carmen.CreateMessageResponse.
 * Use `create(CreateMessageResponseSchema)` to create a new message.
 */
export const CreateMessageResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 11);

/**
 * Describes the message carmen.GetMessageRequest.
 * Use `create(GetMessageRequestSchema)` to create a new message.
 */
export const GetMessageRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 12);

/**
 * Describes the message carmen.GetMessageResponse.
 * Use `create(GetMessageResponseSchema)` to create a new message.
 */
export const GetMessageResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 13);

/**
 * Describes the message carmen.ListMessagesRequest.
 * Use `create(ListMessagesRequestSchema)` to create a new message.
 */
export const ListMessagesRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 14);

/**
 * Describes the message carmen.ListMessagesResponse.
 * Use `create(ListMessagesResponseSchema)` to create a new message.
 */
export const ListMessagesResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 15);

/**
 * Describes the message carmen.UpdateMessageRequest.
 * Use `create(UpdateMessageRequestSchema)` to create a new message.
 */
export const UpdateMessageRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 16);

/**
 * Describes the message carmen.UpdateMessageResponse.
 * Use `create(UpdateMessageResponseSchema)` to create a new message.
 */
export const UpdateMessageResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 17);

/**
 * Describes the message carmen.DeleteMessageRequest.
 * Use `create(DeleteMessageRequestSchema)` to create a new message.
 */
export const DeleteMessageRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 18);

/**
 * Describes the message carmen.DeleteMessageResponse.
 * Use `create(DeleteMessageResponseSchema)` to create a new message.
 */
export const DeleteMessageResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 19);

/**
 * Describes the message carmen.SendStreamingMessageRequest.
 * Use `create(SendStreamingMessageRequestSchema)` to create a new message.
 */
export const SendStreamingMessageRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 20);

/**
 * Describes the message carmen.SendStreamingMessageResponse.
 * Use `create(SendStreamingMessageResponseSchema)` to create a new message.
 */
export const SendStreamingMessageResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_chat_service, 21);

/**
 * @generated from service carmen.ChatService
 */
export const ChatService = /*@__PURE__*/
  serviceDesc(file_proto_service_chat_service, 0);

